import * as Api from '@/utils/request'

let baseURL = '',baseURL2 = '';
if (process.env.NODE_PM === 'prod') {
    baseURL = 'https://app.aigupiao.com';
    baseURL2 = 'https://mobile.aigupiao.com';
} else if (process.env.NODE_PM === 'dev') {
    baseURL = 'https://appdev.aigupiao.com';
    baseURL2 = 'https://mobiledev.aigupiao.com';
} else if (process.env.NODE_PM === 'beta') {
    baseURL = 'https://appbeta.aigupiao.com';
    baseURL2 = 'https://mobilebeta.aigupiao.com';
}


export default {

    //https://appbeta.aigupiao.com/goapi/stock/search?keyword=9&u_id=44324&page=1&number=5

    async stockSearch2(keyword) {
        return await Api.get({
            url: baseURL+'/goapi/stock/search?page=1&number=20',
            params: {keyword}
        })
    },

    async stockSearch(keyword) {
        return await Api.get({
            url: baseURL2+'/calf/search',
            params: {keyword}
        })
    },
    async stockDetail(opt){
        return await Api.post({
            url:baseURL+'/stocksDiagnosis/details',
            params:{
                ...opt
            }
        })
    }
 

}